import React from 'react';
import { attributeTypes, Images } from 'utils';
import { SelectTypeAutocomplete, TextRow } from 'components';
import { inputDateTypeList, inputTypeEnums, selectDateTypeList } from '../../attributes/constnats';
import { OptionsSection } from './optionsSection';
import { TableColumnsSection } from './tableColumnsSection';

const placeholderInputSubtypes = [inputTypeEnums.TEXT, inputTypeEnums.NUMBER, inputTypeEnums.EMAIL];

export const ContentSection = ({ selectedItem, handleUpdate, handleAttributeChange, getFilteredAttributes, selectedIndex }) => {
    const showPlaceholder =
        selectedItem?.type === attributeTypes.RICH_TEXT ||
        selectedItem?.type === attributeTypes.SELECT ||
        (selectedItem?.type === attributeTypes.INPUT && placeholderInputSubtypes.includes(selectedItem?.defaultDateType));

    return (
        <div className="properties-section">
            <div className="section-header">
                <img src={Images.contentIcon} alt="contentIcon" />
                <span>CONTENT</span>
            </div>

            <div className="props-input-group">
                <div className="props-label">Label</div>
                <input
                    type="text"
                    className="custom-input"
                    value={selectedItem?.label || ''}
                    onChange={(e) => handleUpdate('label', e.target.value)}
                />
            </div>

            {showPlaceholder && (
                <div className="props-input-group">
                    <div className="props-label">Placeholder</div>
                    <input
                        type="text"
                        className="custom-input"
                        value={selectedItem?.placeholder || ''}
                        onChange={(e) => handleUpdate('placeholder', e.target.value)}
                        // placeholder="Enter placeholder text..."
                    />
                </div>
            )}

            {!selectedItem?.properties?.updateForbidden && handleAttributeChange && (
                <div className="props-input-group">
                    <div className="props-label">Attribute Type</div>
                    <SelectTypeAutocomplete
                        disableClearable={true}
                        name="type"
                        handleSelect={(selected) => handleAttributeChange(selectedIndex, selected)}
                        defaultValue={selectedItem?.type}
                        list={getFilteredAttributes(selectedIndex)}
                        renderValue={(i) => i?.displayLabel || i?.label}
                        uiType={'tableFilter'}
                        noError={true}
                        customOptions={(item) => (
                            <div className="flex-align-center" style={{ gap: 8 }}>
                                <div style={{ width: 20, minWidth: 20, maxWidth: 20 }}>
                                    <img src={item?.img} alt="icon" style={{ width: '16px', height: '16px', marginTop: '6px' }} />
                                </div>
                                <TextRow name={item?.displayLabel || item?.label} textWidth={7} />
                            </div>
                        )}
                    />
                </div>
            )}

            {!selectedItem?.properties?.updateForbidden && selectedItem?.defaultDateType && selectedItem?.type !== attributeTypes.GRAPH && (
                <div className="props-input-group">
                    <div className="props-label">Type</div>
                    <SelectTypeAutocomplete
                        disableClearable={true}
                        name="defaultDateType"
                        handleSelect={(event) => {
                            handleUpdate('defaultDateType', event.target.value);
                        }}
                        defaultValue={selectedItem?.defaultDateType}
                        list={
                            selectedItem?.type === attributeTypes.SELECT
                                ? selectDateTypeList
                                : selectedItem?.type === attributeTypes.INPUT
                                  ? inputDateTypeList
                                  : []
                        }
                        renderValue={(i) => i?.name}
                        uiType={'tableFilter'}
                        noError={true}
                    />
                </div>
            )}

            {(selectedItem?.type === attributeTypes.SELECT ||
                selectedItem?.type === attributeTypes.CHECK_BOX ||
                selectedItem?.type === attributeTypes.RADIO_BUTTON) && (
                <OptionsSection selectedItem={selectedItem} handleUpdate={handleUpdate} />
            )}

            {selectedItem?.type === attributeTypes.TABLE && <TableColumnsSection selectedItem={selectedItem} handleUpdate={handleUpdate} />}
        </div>
    );
};
